import {
  ABOUT,
  ANALYTICS,
  BILLING,
  COMMENTS,
  SALES,
  EVENTS,
  HEADSETS,
  OFFLINE_HEADSETS,
  DEVICE_EVENTS,
  HOTELS,
  META,
  METRICS,
  PAYMENTS,
  PROBLEMS,
  REPORTS,
  SERVICE,
  SETTINGS,
  SUBSCRIPTION,
  USER_EVENTS,
  BATTERY_LOGS,
} from 'src/constants';

export enum RoleEnum {
  accountant = 'accountant',
  admin = 'admin',
  engineer = 'engineer',
  observer = 'observer',
  reception = 'reception',
  airpano = 'airpano',
}

export const rulesMap: Record<string, Record<string, RoleEnum[]>> = {
  [REPORTS]: {
    [SALES]: [RoleEnum.admin, RoleEnum.observer, RoleEnum.airpano],
    [PROBLEMS]: [
      RoleEnum.admin,
      RoleEnum.observer,
      RoleEnum.reception,
      RoleEnum.engineer,
    ],
    [BILLING]: [RoleEnum.admin, RoleEnum.observer],
    [OFFLINE_HEADSETS]: [RoleEnum.admin, RoleEnum.observer, RoleEnum.airpano],
  },
  [SERVICE]: {
    [HEADSETS]: [RoleEnum.admin],
    [DEVICE_EVENTS]: [RoleEnum.admin],
    [ANALYTICS]: [RoleEnum.admin, RoleEnum.observer],
  },
  [HOTELS]: {
    [HEADSETS]: [
      RoleEnum.admin,
      RoleEnum.engineer,
      RoleEnum.observer,
      RoleEnum.reception,
      RoleEnum.airpano,
    ],
    [METRICS]: [RoleEnum.admin, RoleEnum.observer],
    [ANALYTICS]: [RoleEnum.admin, RoleEnum.observer],
    [BILLING]: [
      RoleEnum.admin,
      RoleEnum.accountant,
      RoleEnum.observer,
      RoleEnum.airpano,
    ],
    [ABOUT]: [RoleEnum.admin, RoleEnum.engineer],
  },
  [HEADSETS]: {
    [SETTINGS]: [RoleEnum.admin, RoleEnum.engineer],
    [SUBSCRIPTION]: [RoleEnum.admin, RoleEnum.observer, RoleEnum.reception],
    [BILLING]: [RoleEnum.admin, RoleEnum.observer, RoleEnum.reception],
    [EVENTS]: [RoleEnum.admin],
    [USER_EVENTS]: [RoleEnum.admin],
    [PAYMENTS]: [
      RoleEnum.admin,
      RoleEnum.observer,
      RoleEnum.reception,
      RoleEnum.engineer,
    ],
    [COMMENTS]: [RoleEnum.admin, RoleEnum.engineer],
    [META]: [RoleEnum.admin, RoleEnum.engineer],
    [BATTERY_LOGS]: [RoleEnum.admin],
  },
};
